export default "__VITE_ASSET__mXrU9yvZ__"